import {call, put} from 'redux-saga/effects';
import {receiveServiceLevelProductsData} from "../actions/serviceLevelProductsActions";
import {fetchServiceLevelProductsData} from "../api/fetchServiceLevelProductsData";

export default function* getServiceLevelsContentData(action) {
  try {
    const serviceLevelsContentData = yield call(fetchServiceLevelProductsData);
    yield put(receiveServiceLevelProductsData(serviceLevelsContentData));
  } catch (e) {
    console.log(e)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/serviceLevelProductsSaga.js